// Homepage-specific components
import { _ } from './utils'
import ProductBlockLoader from './modules/product-blocks-loader'
import smoothScroll from './modules/smooth-scroll'
import SearchModal from './modules/search-modal'
import Video from './modules/video'

_('smooth-scroll')
    .nodes()
    .forEach((el) => smoothScroll(el))

const siteSearchModal = document.querySelector('[data-element="site-search"].site-search')
if (siteSearchModal) {
    new SearchModal(siteSearchModal)
}
_('video', 'element')
    .nodes()
    .forEach((el) => new Video(el))

new ProductBlockLoader()
